// extracted by mini-css-extract-plugin
export default {"description":"C5j1MxAHI4iknVkXFdxk"};